module.exports = __webpack_public_path__ + "static/media/typeface-logo-stg2.ad0d8d81.svg";